import { ApplicationRoutes } from '../../../app-routes-names'

export const TiresRoutes = {
  list: 'list',
  summaryProgram: 'summary-program',
  summarylevels: 'summary-levels',
  summaryStockable: 'summary-stockable',
  summaryRotation: 'summary-rotation',
  summaryPayment: 'summary-payment',
  lostTire: 'lost-tire',
  lostTiresList: 'lost-tire-list',
  offers: 'offers',
  inventorySummary: 'inventory-summary',
  inventoryList: 'inventory-list',
  order: 'order',
  orderRefill: 'order-refill',
  usafOverview: 'usaf-overview',
  usafOrders: 'usaf-orders',
  usafAutoOrders: 'usaf-auto-orders',
  usafLeftovers: 'usaf-leftovers',
  usafOverdueOrders: 'usaf-overdue-orders',
  usafOrderLines: 'usaf-order-lines',
  usafInvoices: 'usaf-invoices'
}

const { tires } = ApplicationRoutes

export const TiresPaths = {
  list: `/${tires}/${TiresRoutes.list}`,
  summaryProgram: `/${tires}/${TiresRoutes.summaryProgram}`,
  summarylevels: `/${tires}/${TiresRoutes.summarylevels}`,
  summaryStockable: `/${tires}/${TiresRoutes.summaryStockable}`,
  summaryRotation: `/${tires}/${TiresRoutes.summaryRotation}`,
  summaryPayment: `/${tires}/${TiresRoutes.summaryPayment}`,
  lostTire: `/${tires}/${TiresRoutes.lostTire}`,
  lostTiresList: `/${tires}/${TiresRoutes.lostTiresList}`,
  offers: `/${tires}/${TiresRoutes.offers}`,
  inventorySummary: `/${tires}/${TiresRoutes.inventorySummary}`,
  inventoryList: `/${tires}/${TiresRoutes.inventoryList}`,
  order: `/${tires}/${TiresRoutes.order}`,
  orderRefill: `/${tires}/${TiresRoutes.orderRefill}`,
  usafOverview: `/${tires}/${TiresRoutes.usafOverview}`,
  usafOrders: `/${tires}/${TiresRoutes.usafOrders}`,
  usafAutoOrders: `/${tires}/${TiresRoutes.usafAutoOrders}`,
  usafLeftovers: `/${tires}/${TiresRoutes.usafLeftovers}`,
  usafOverdueOrders: `/${tires}/${TiresRoutes.usafOverdueOrders}`,
  usafOrderLines: `/${tires}/${TiresRoutes.usafOrderLines}`,
  usafInvoices: `/${tires}/${TiresRoutes.usafInvoices}`,
  usafOrderDetail: (orderId: string) => `/${tires}/${TiresRoutes.usafOrders}/${orderId}`,
  orderForLocation: (locationId: string) => `/${tires}/${TiresRoutes.order}/${locationId}`
}
